import React, { useEffect, useState } from "react";
import AskAddyV2 from "../../models/askAddyV2";
import DocView, { AboutFile } from "./DocView";

/**
 * Who the assistant is in your chats, opened under its row in Identity: the picked agent's
 * instructions from AI Agents, or Lendy's when none is picked. Read-only: they're edited where the
 * agent is managed.
 */
const InstructionsView = ({ identity, agentId, assistantName }) => {
  const [assistant, setAssistant] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let isCurrent = true;
    setAssistant(null);
    setError("");
    const load = async () => {
      try {
        const loaded = await AskAddyV2.assistant(identity, agentId);
        if (isCurrent) {
          setAssistant(loaded);
        }
      } catch (loadError) {
        if (isCurrent) {
          setError(loadError.message);
        }
      }
    };
    load();
    return () => {
      isCurrent = false;
    };
  }, [identity, agentId]);

  return (
    <div className="lendy-profile-editor lendy-profile-editor--inline lendy-profile-doc">
      <AboutFile>
        {assistant?.appID
          ? `Who ${assistantName} is, from the instructions your organization wrote for it in AI Agents. Change them there.`
          : `${assistantName} is Addy's own assistant. Pick one of your organization's agents to answer with its instructions.`}
      </AboutFile>
      {!assistant && !error && <p className="lendy-profile-note">Loading…</p>}
      {assistant && <DocView markdown={assistant.instructions || ""} />}
      {error && (
        <p className="lendy-profile-note lendy-profile-note--error">
          {error}
        </p>
      )}
    </div>
  );
};

export default InstructionsView;
